import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

const ProgressBarContainer = styled.div`
  width: 80%;
  height: 8px;
  min-width: 100px;
  background-color: ${({ theme }) => defaultTheme.COLORS.GRAY_MEDIUM}66;
  border-radius: 10px;
  margin-right: 15%;
`;

const ProgressBarFiller = styled.div<{ $percentage: number }>`
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(45deg, #f0affa 14.64%, #ffc77d 85.36%);
  transition: width 0.2s ease-in;
  width: ${({ $percentage }) => `${$percentage}%`};
`;

interface Props {
  percentage: number;
}

export const ProgressBar = ({ percentage }: Props) => {
  return (
    <ProgressBarContainer>
      <ProgressBarFiller $percentage={percentage} />
    </ProgressBarContainer>
  );
};
